import authSagas from "./auth";
import userManagementSaga from "./userManagement";
import settingsSagas from "./settings";
import alertsSaga from "./alerts";
import accountSagas from "./account";

const sagas = [
  authSagas,
  userManagementSaga,
  settingsSagas,
  alertsSaga,
  accountSagas,
]

const registerSagas = (middleware) => {
  sagas.forEach((saga) => {
    middleware.run(saga)
  })
}

export default registerSagas;